import { useDashboard } from '@/hooks/useDashboard';
import { useDashboardSubscription } from '@/hooks/useDashboardSubscription';
import { useDayState } from '@/hooks/useDayState';
import { useWakeLock } from '@/hooks/useWakeLock';
import { BentoGrid } from '@/components/dashboard/BentoGrid';
import { BackPageCard } from '@/components/cards/BackPageCard';
import { DayStatePreview } from '@/components/shared/DayStatePreview';

export function WallRoute() {
  useWakeLock();
  useDashboardSubscription();
  const { data, isLoading, error } = useDashboard();
  const dayState = useDayState();

  if (isLoading || !data) {
    return (
      <div className="min-h-screen flex items-center justify-center text-inkFaded font-serif italic text-display-sm">
        {error ? 'The wall is quiet for a moment.' : 'Loading…'}
      </div>
    );
  }

  return (
    <div className="min-h-screen p-7">
      {dayState === 'night' ? (
        <BackPageCard dashboard={data} />
      ) : (
        <BentoGrid dashboard={data} dayState={dayState} />
      )}
      <DayStatePreview active={dayState} />
    </div>
  );
}
